export type DossierPeriod =
	| 'all'
	| 'last7Days'
	| 'last30Days'
	| 'last3Months'
	| 'last12Months'
	| 'olderThanOneYear';

/** Period presets of the dossier tabs, rolling back from today. */
const dossierPeriodOptions: ReadonlyArray<{ readonly value: DossierPeriod; readonly label: string }> =
	Object.freeze([
		{ value: 'all', label: 'Toutes les dates' },
		{ value: 'last7Days', label: '7 derniers jours' },
		{ value: 'last30Days', label: '30 derniers jours' },
		{ value: 'last3Months', label: '3 derniers mois' },
		{ value: 'last12Months', label: '12 derniers mois' },
		{ value: 'olderThanOneYear', label: "Plus d'un an" },
	]);

export default dossierPeriodOptions;
